import React, { useCallback, useEffect, useState } from "react";
import { Content } from "../../components/Containers";
import List from "../../components/List";
import { useModal } from "../../context/ModalContext";
import EditAttributes from "./Edit";
import AttributeCard from "./AttributeCard";
import { createAttribute, deleteAttribute, getAttribute, importAttributeExcelData, searchAttributes, updateAttribute } from "../../api/Attribute";
import { getAllDrinks } from "../../api/Drink";
import SelectField from "../../components/SelectField";
import { listCategoriesByDrinkId } from "../../api/Category";
import { ATTRIBUTE_TYPE_OPTIONS } from "../../constants/Consts";


export default function Attributes({ navigate, location }) {
  const { showModal } = useModal();
  const [query, setQuery] = useState("");
  const [all, setAll] = useState(false);
  const [page, setPage] = useState(0);
  const [data, setData] = useState({ content: [] });
  const [selected, setSelected] = useState();
  const [drinkOptions, setDrinkOptions] = useState([]);
  const [selectedDrinkId, setSelectedDrinkId] = useState(!!location?.state?.drinkId ? location.state.drinkId : "");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(!!location?.state?.categoryId ? location.state.categoryId : "");
  const [selectedAttrType, setSelectedAttrType] = useState("");

  useEffect(() => {
    const initPage = async () => {
      const res = await getAllDrinks("nameBr", "ASC");
      setDrinkOptions(res.map(r => ({ label: r.nameBr, value: r.id })));
    }

    initPage();
  }, [location]);

  useEffect(() => {
    const load = async () => {
      const res = await listCategoriesByDrinkId(selectedDrinkId);
      setCategoryOptions(res.map(r => ({ label: r.nameBr, value: r.id })));
    }

    if(!!selectedDrinkId){
      load();
    }
  }, [selectedDrinkId]);

  const load = useCallback(() => {
    console.log(selectedCategoryId)
    const search = async () => setData(await searchAttributes(query, all, page, "order", "ASC", selectedDrinkId, selectedCategoryId, selectedAttrType));
    search();
  }, [query, all, page, selectedDrinkId, selectedCategoryId, selectedAttrType]);

  useEffect(() => {
    load();
  }, [query, all, page, load]);

  const importExcel = async (data) => {
    try {
      await  importAttributeExcelData(data);
      load();
      showModal("Atributos importados com sucesso!", "success", 10);
    } catch (e) {
      console.log(e.message ?? e);
      showModal("Falha ao importar atributos", "error", 10);
    }
  }

  return (
    <>
      <Content>
        <List
          data={data}
          query={query}
          updateQuery={setQuery}
          status={all}
          updateStatus={setAll}
          statusList={[
            { label: "Todos", value: true },
            { label: "Ativos", value: false },
          ]}
          updatePage={setPage}
          onNew={() =>
            setSelected({
              nameBr: "",
              order: 0,
              descriptionBr: "",
              category: "",
              type: "",
              hexStartColor: "#FFFF00",
              hexMiddleColor: "#BA652F",
              hexEndColor: "#000000",
            })
          }
          Item={(item) => (
            <AttributeCard
              key={"ku" + item.id}
              attribute={item}
              onEdit={async () => {
                const loaded = await getAttribute(item);
                setSelected(loaded);
              }}
              onDelete={async () => {
                try {
                  await deleteAttribute(item);
                  load();
                } catch (e) {
                  showModal("O atributo não pode ser apagado", "warn", 10);
                }
              }}
              onFilter={() => navigate(
                "/traits", 
                { state: { drinkId: item.category.drink.id, categoryId: item.category.id, attributeId: item.id } }
              )}
            />
          )}
          renderBeforeContent={
            <div className="mt-[-20px] mb-6 flex flex-row gap-6 flex-wrap">
              <SelectField
                label="Tipo"
                className="w-[200px]"
                value={selectedAttrType} 
                options={ATTRIBUTE_TYPE_OPTIONS} 
                update={(v) => setSelectedAttrType(v)} 
              />
              <SelectField
                label="Bebida"
                className="w-[200px]"
                value={selectedDrinkId} 
                options={drinkOptions} 
                update={(v) => setSelectedDrinkId(v)} 
              />
              { !!selectedDrinkId &&
                <SelectField
                  label="Categoria"
                  className="w-[200px]"
                  value={selectedCategoryId} 
                  options={categoryOptions} 
                  update={(v) => setSelectedCategoryId(v)} 
                />
              }
            </div>
          }
          onReadExcelInput={importExcel}
          excelExampleHeaders={["nameBr", "order", "categoryId", "type", "hexStartColor", "hexMiddleColor", "hexEndColor", "textLimit"]}
        />
      </Content>
      <EditAttributes
        selected={selected}
        onClose={() => setSelected(null)}
        onSave={async (style) => {
          try {
            if (!!style.id) {
              await updateAttribute(style);
            } else {
              await createAttribute(style);
            }
            setSelected(null);
            load();
          } catch (e) {
            showModal("Falha ao gravar atributo", "error", 10);
          }
        }}
        drinkOptions={drinkOptions}
      />
    </>
  );
}
